export const DETAIL_TAB_PARAM_KEY = "verticalSignPole-details"
